export default __webpack_public_path__ + "static/media/undraw_doctors.dba3882a.svg";